// Principal.js
import React, { useState, useEffect } from 'react';
import Intro from '../componentes/Intro';
import '../estilos/Principal.css';
import Privado from './Privado';
import Publico from './Publico';
import Consultoria from './Consultoria';

const Principal = () => {
  const [showIntro, setShowIntro] = useState(false);
  const [sector, setSector] = useState(null);

  useEffect(() => {
    // Disable scrolling when the intro is shown
    if (showIntro) {
      if(document && document.body){
      document.body.style.overflow = 'hidden';
      }
    } else {
      if(document && document.body){
      document.body.style.overflow = 'auto';
      }
    }
  }, [showIntro]);

  const handleComplete = (sector) => {
    console.log("handl sector",sector)
    setShowIntro(false);
    setSector(sector)
  };


  return (
    <div className={`Principal ${!showIntro ? 'show-content' : ''}`}>
      <Intro onComplete={handleComplete} />



      {/* <div className="main-content">
        <h1>Main Platform Content</h1>
        <p>This is where the main content of the platform will be displayed.</p>
      </div>*/}


      {sector == "PRIVADO" ?
        <Privado />
        :
        <>
          {sector == "PUBLICO" ?
            <Publico/>
            :
            <>
              {sector == "CONSULTORIA" ?
                <Consultoria/>
                :
                null
              }
            </>
          }
        </>
      }


    </div>
  );
};

export default Principal;


/*
import React from "react";
import BallAnimation from "../componentes/BallAnimation";
import Intro from '../componentes/Intro';

function Principal() {
  return (
    <div className="App">
      <Intro />
      <BallAnimation />
    </div>
  );
}

export default Principal;*/
